//constants
import { STATE_IDENTIFIER } from "./SecurityQuestionsConstants";

//utils
import { prop } from "ramda";
import { createSelector } from "reselect";

const { QUESTIONS, QUESTIONS_LOADER, REQUEST_STATE } = STATE_IDENTIFIER;

const securityQuestionsSelector = (state: any) => state.securityQuestions;

export const selectQuestions: any = createSelector(
  securityQuestionsSelector,
  prop(QUESTIONS)
);

export const selectQuestionsLoader: any = createSelector(
  securityQuestionsSelector,
  prop(QUESTIONS_LOADER)
);

export const selectResponseStatus: any = createSelector(
  securityQuestionsSelector,
  prop(REQUEST_STATE)
);
